// Auto generated file, do not manually modify!
// com.hotpads.zcalendar.client.enums.TourActionButton

export enum TourActionButton {
  CANCEL = 'CANCEL',
  CONFIRM = 'CONFIRM',
  DECLINE = 'DECLINE',
  IRENE_RESCHEDULE = 'IRENE_RESCHEDULE',
}

export const TourActionButton_values = [
  TourActionButton.CANCEL,
  TourActionButton.CONFIRM,
  TourActionButton.DECLINE,
  TourActionButton.IRENE_RESCHEDULE,
] as const;
